<template>
    <vue-final-modal v-model="showModal" classes="modal-container" content-class="modal-content" name="popUpAggiungiRicambio">
    <div class="BtnClose">
        <span style="cursor:pointer"><mdi-close @click="this.closeModal()" ></mdi-close></span>
    </div>    
    <div class="PopUpBox">
        <div class="PopUpTitle Iconed AddSpare">Aggiungi ricambio</div>
        <div class="PopUpContent">
            <form class="Form PopupForm">
                <fieldset>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <label>Codice ricambio</label>
                            <select class="CustomSelect" name="" id="CodiceArticoloSelModal">
                                <option value="default">Seleziona</option>
                                <option v-for="articolo in this.listaArticoliRicambi" :key="articolo.CodiceArticolo" :value="articolo.CodiceArticolo">{{ articolo.CodiceArticolo +" - " + articolo.DescrizioneArticolo }}</option>                              
                            </select>
                            <input type="text" id="CodiceArticoloSelText" v-model="this.codiceArticoloSel" name="" style="display:none;">
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <label>Codice Articolo</label>
                            <div class="InputPlaceHolder">{{ (this.articoloSel ? this.articoloSel.CodiceArticolo  : "") }}</div>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <label>Descrizione</label>
                            <div class="InputPlaceHolder">{{ (this.articoloSel ? this.articoloSel.DescrizioneArticolo : "") }}</div>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <label>Unità</label>
                            <div class="InputPlaceHolder">{{ (this.articoloSel ? this.articoloSel.UnitaMisura : "") }}</div>
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <label>Q.tà effettiva</label>
                            <input type="text" id="" name="" placeholder="Quantità effettiva" v-model="this.quantitaArticoloSel">
                        </div>
                    </div>
                    <div class="FormRow" ref="BoxMagazzini" style="display:none;">
                        <div class="FormBoxWide">
                            <label>Magazzino</label>
                            <select class="CustomSelect" name="" id="CodiceMagazzinoSelModal" v-model="this.codiceMagazzinoSel">
                                <option value="">Seleziona</option>
                                <option v-for="articolo in this.listaMagazzini" :key="articolo.CodiceMagazzino" :value="articolo.CodiceMagazzino">{{ articolo.DescrizioneMagazzino }}</option>                              
                            </select>
                            <input type="text" id="CodiceMagazzinoSelTextModal" v-model="this.codiceMagazzinoSel" name="" style="display:none;">
                        </div>
                    </div>
                    <div class="FormRow">
                        <div class="FormBoxWide">
                            <div class="TwinButtons">
                                <div class="Button Small"><input type="button"  value="Aggiungi ricambio" @click="this.aggiungiRicambio()"></div>
                                <div class="Button Small"><input type="button"  value="Annulla" @click="this.closeModal()"></div>
                            </div>
                        </div>
                    </div>
                </fieldset>
            </form>
        </div>
    </div>
    </vue-final-modal>    
</template>

<script>

import MdiClose from "@/components/modals/MdiClose.vue";
import {apiMixin} from "/mixin.js";

export default {
    name: "AggiungiRicambioModal",
    mixins: [apiMixin],
    
    props:{
        showModal: Boolean,
        attivita: Object,      
    },   
    data(){
        return {
            codiceArticoloSel: "",           
            quantitaArticoloSel: 0,           
            codiceMagazzinoSel: "",            
            articoloSel: null,
            showMagazzini: false
        }
    },
    computed: {
        listaArticoliRicambi: function(){
            return this.$store.getters.getArticoliFornitore;
        },
        listaMagazzini: function(){
            return this.$store.getters.getMagazzini;
        }    
    },    
    watch:{
        codiceArticoloSel: function(val){        
            this.articoloSel = this.listaArticoliRicambi.find(item => {return item.CodiceArticolo === val});
            if(this.articoloSel != null){
                if(this.articoloSel.CheckMagazzino){
    
                    this.$refs.BoxMagazzini.style.display = "block";               
                    
                    $('#CodiceMagazzinoSelModal').select2({
                        theme: "classic"
                    });             
                }
                else{
                    this.$refs.BoxMagazzini.style.display = "none"; 
                }
            }
        }
    }, 
    components:{        
        MdiClose
    },
    methods:{
        closeModal: function(){    
            this.codiceArticoloSel=""
            this.articoloSel=null;          
            this.quantitaArticoloSel=0;        
            this.codiceMagazzinoSel= "";          
            this.showMagazzini= false;
            this.$refs.BoxMagazzini.style.display = "none"; 
            const elem = document.querySelector("#CodiceArticoloSelModal");
            elem.value = "default";
            this.$vfm.hide('popUpAggiungiRicambio');
        },
        aggiungiRicambio(){
            if(!this.codiceArticoloSel){
                this.$toast.error("Impossibile inserire il ricambio, codice articolo mancante!", {position:"top-right"});       
                return;
            }
            if(!this.quantitaArticoloSel){
                this.$toast.error("Impossibile inserire il ricambio, quantità mancante!", {position:"top-right"});       
                return;
            }
            if(this.articoloSel && this.articoloSel.CheckMagazzino && !this.codiceMagazzinoSel){
                this.$toast.error("Obbligatorio selezionare un magazzino!", {position:"top-right"});       
                return;
            }

            let postBody =  {

                GlbAttivita: this.attivita.SysChiaveglobale, 
                CodiceArticolo: this.codiceArticoloSel,
                QtaEffettiva: parseInt(this.quantitaArticoloSel),
                CodiceMagazzino: this.codiceMagazzinoSel
            };         
            this.doApiCall("post", "interventi/InsertRicambio", this.$store.getters.getUtente.Token, null, postBody).then(

                (data) => {             
                    if(data.StatusCode === 200){
                        this.$toast.success("Ricambio inserito con successo!", {position:"top-right"});
                
                        this.$parent.$data.listaRicambi.push(data.Data);
                        this.$parent.$forceUpdate();
                        this.closeModal();
                    }
                    else{
                        this.$toast.error("Attenzione! Si sono verificati errori durante il salvataggio del ricambio!", {position:"top-right"});
                    }
                },                
            );
        },       
    },
    mounted(){ 
        $('#CodiceArticoloSelModal').on('select2:select', function (e) {                               
            var el = document.getElementById('CodiceArticoloSelText');
            el.value=e.params.data.id;
            el.dispatchEvent(new Event('input'));
        });
        $('#CodiceMagazzinoSelModal').on('select2:select', function (e) {                               
            var el = document.getElementById('CodiceMagazzinoSelTextModal');
            el.value=e.params.data.id;
            el.dispatchEvent(new Event('input'));
        });
    },  
}
</script>
<style>

.modal-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
.modal-content {
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;
    width: 440px;  
}

.BtnClose{ 
    text-align: right;
}

.modal__close { 
    background: none;
}
</style>

